(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-result/assets/javascripts/ball-row-result-eurojackpot.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-result/assets/javascripts/ball-row-result-eurojackpot.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.result = svs.tur.ball.row.result || {};
class Eurojackpot extends svs.tur.ball.row.result.Default {
  constructor(options) {
    options.row = new svs.tur.ball.row.Eurojackpot(options);
    super(options);
  }
  classNames() {
    return ['ball-row-result-eurojackpot'];
  }
}
svs.tur.ball.row.result.Eurojackpot = Eurojackpot;

 })(window);